import { TRACKERS } from "@/constants/Trackers";
import { Labs } from "@/features/Patient/MedicalRecords/Labs/Labs";
import { trackEvent } from "@/lib/tracking";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/labs")({
  component: RouteComponent,
  onEnter: async () => {
    trackEvent(TRACKERS.NAVIGATE_TO_LABS);
  },
});

function RouteComponent() {
  return <Labs />;
}
